import { Pipe, PipeTransform } from '@angular/core';
import { IdName } from '../../models';
import { enumToList } from '../enum-to-list';
import { AuditLogComponent } from '../../enums/audit-log-component.enum';

@Pipe({
  name: 'auditLogComponent',
  standalone: false
})
export class AuditLogComponentPipe implements PipeTransform {
  public transform(value: AuditLogComponent): string {
    return getAuditLogComponent(value);
  }
}

export function getAuditLogComponent(value: AuditLogComponent): string {
  switch (value) {
    case AuditLogComponent.UserManagement:
      return 'User Management';
    case AuditLogComponent.Locations:
      return 'Locations';
    case AuditLogComponent.Shifts:
      return 'Shifts';
    case AuditLogComponent.ActivityTypes:
      return 'Activity Types';
    case AuditLogComponent.Programs:
      return 'Programs';
    case AuditLogComponent.Groups:
      return 'Groups';
    case AuditLogComponent.AgencyInformation:
      return 'Agency Information';
    case AuditLogComponent.FormsSettings:
      return 'Form Settings';
    case AuditLogComponent.Phases:
      return 'Phases';
    case AuditLogComponent.PerformanceCategories:
      return 'Performance Categories';
    case AuditLogComponent.Ratings:
      return 'Ratings';
    case AuditLogComponent.ProgramSkills:
      return 'Program Skills';
    case AuditLogComponent.QuizzesSettings:
      return 'Quiz Settings';
    case AuditLogComponent.Quizzes:
      return 'Quizzes';
    case AuditLogComponent.Alerts:
      return 'Alerts';
    case AuditLogComponent.IncidentTypes:
      return 'Incident Types';
    case AuditLogComponent.CorrectiveActions:
      return 'Corrective Actions';
    case AuditLogComponent.Users:
      return 'Users';
    case AuditLogComponent.UserProfile:
      return 'User Profile';
    case AuditLogComponent.Resources:
      return 'Resources';
    case AuditLogComponent.Schedule:
      return 'Schedule';
    case AuditLogComponent.Forms:
      return 'Forms';
    case AuditLogComponent.Reports:
      return 'Reports';
    case AuditLogComponent.SiteSkills:
      return 'Site Skills';
    case AuditLogComponent.AddOns:
      return 'Add-Ons';
    case AuditLogComponent.ProgramExitTypes:
      return 'Program Exit Types';
    case AuditLogComponent.TrainingCourses:
      return 'Training Courses';
    case AuditLogComponent.ProgramTasks:
      return 'Program Tasks';
    case AuditLogComponent.SiteCallTypes:
      return 'Site Call Types';
    case AuditLogComponent.Skills:
      return 'Skills';
    case AuditLogComponent.Search:
      return 'Search';
    default:
      throw new Error(`Unsupported value for AuditLogComponent: ${value}.`);
  }
}

export function getAuditLogComponentList(): IdName[] {
  return enumToList(AuditLogComponent, getAuditLogComponent);
}
